export enum ITEM_STATUS {
  INACTIVE = 'INATIVO',
  ACTIVE = 'ATIVO',
}
